import { ReactNode, useCallback } from 'react';
import { OptionsObject, SnackbarKey, useSnackbar } from 'notistack';

import {
  AUTO_HIDE_DURATION_TIME,
  NOTIFICATION_TYPES,
} from '@components/Notification';

import LeaveStyleStudioEventNotification from '@clients/ek/components/StyleStudio/LeaveStyleStudioEventNotification/LeaveStyleStudioEventNotification';
import { useOverlayContext } from '@providers/OverlayProvider';

export interface ILeaveStyleStudioNotificationProps extends OptionsObject {
  message: string | ReactNode;
  type: NOTIFICATION_TYPES;
  closeManually?: boolean;
  onCancel: () => void;
  onLeave: () => void;
}

export type ShowLeaveStyleStudioEventNotificationType = (
  props: ILeaveStyleStudioNotificationProps,
) => SnackbarKey;

export type UseNotificationMessageType = () => {
  showLeaveStyleStudioEventNotification: ShowLeaveStyleStudioEventNotificationType;
};

const useNotificationMessage: UseNotificationMessageType = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { setHideCurrentlyOpenOverlays } = useOverlayContext();

  const showLeaveStyleStudioEventNotification: ShowLeaveStyleStudioEventNotificationType =
    useCallback(
      ({
        message,
        type,
        closeManually = false,
        onLeave,
        onCancel,
        ...options
      }) => {
        return enqueueSnackbar(null, {
          autoHideDuration: closeManually ? null : AUTO_HIDE_DURATION_TIME,
          preventDuplicate: true,
          content: (key) => (
            <LeaveStyleStudioEventNotification
              id={key}
              message={message}
              type={type}
              onLeave={onLeave}
              onCancel={onCancel}
              setHideCurrentlyOpenOverlays={setHideCurrentlyOpenOverlays}
            />
          ),
          ...options,
        });
      },
      [enqueueSnackbar, setHideCurrentlyOpenOverlays],
    );

  return { showLeaveStyleStudioEventNotification };
};

export default useNotificationMessage;
